export function normalizePhoneNumber(value: string): string {
  const trimmed = value.trim();
  if (!trimmed) return '';

  const withInternationalPrefix = trimmed.replace(/^\+/, '00');
  return withInternationalPrefix.replace(/\D/g, '');
}

export function isPhoneNumber(value: string): boolean {
  return /^[0-9]+$/.test(value);
}
